<template>
	<div class="small-nav">
        <div style="margin-right: 14px;" class="filters">
            <span 
            class="filter-option" 
            :class="{'active': activeFilters.includes(filter)}" 
            v-for="(filter, index) in this.getSearchFilters" 
            :key="index" 
            @click="setActiveFilter(filter, getCurrentPartType)">
                {{filter}}
            </span>
            <div class="view-options">
                <span @click="setLayout('simple')" style="font-size: 25px !important"  class="icon icon-list list-option"  :class="{'active': getLayout == 'simple'}"></span>
                <span @click="setLayout('advanced')" style="margin-left: 2px;font-size: 25px !important" class="icon icon-gauge album-option" :class="{'active': getLayout == 'advanced'}"></span>
                <span @click="setLayout('compare')" style="font-size: 25px !important"  class="icon icon-text list-option"  :class="{'active': getLayout == 'compare'}"></span><div v-if="getCompareList[getType()]" class="notification">{{getCompareList[getType()].length}}</div>
                <div  class="compat-mode-button" @click="compatMode(!getCompatibleMode)">
                    <span style="font-size: 14.5px !important; "> 
                      Compatible Only
                      <input style="margin-left: 8px; color: #434857" :checked="getCompatibleMode == true" type="checkbox" />
                    </span>
                </div>
            </div>
        </div>
        <div style="margin-top: 5px; margin-left: auto;">
            <div v-if="filterClicked" style="margin-top: -2px;" class="dropdown">
                <div class="gixcore-dropdown" :class="{'clicked':sortByClicked}">
                    <div class="sort-by-content"  v-for="option in getSortBy" :key="option.id">
                        <a v-if="sortByClicked==false && option.chosen==true" href="#" @click.stop="show" >{{option.name}}</a>
                        <a v-else-if="sortByClicked==true"  @click="sortItems({option: option, items: items})" v-click-outside="hide" href="#">{{option.name}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters}    from 'vuex'
import ClickOutside                 from 'vue-click-outside'


export default {
    name: 'smallnav',
    props: ["viewModes", "items"],
    directives: {
        ClickOutside
    },
    data() {
        return {
            type:                   '',
            item: '',
            filterClicked:          true,
            sortByClicked:          false,
            activeFilters:          [],
            activeFiltersV2:        {},
            filters: {
                cpu:            ['8 cores', '4 cores', 'Intel', 'AMD'],
                motherboard:    ['Intel', 'AMD', 'ATX', 'MicroATX'],
                ram:            ['8GB', '16GB', '32GB'],
                storage:        ['SSD', 'HDD', '2TB', '4TB', '1TB', 'NVMe', 'SATA', 'M.2'],
                graphics:       [''],
                psu:            [''],
                case:           [''],
            }
        }
    },
    computed: {
        ...mapGetters([
            'getLayout',
            'getCompatibleMode',
            'getCompareList',
            'getSortBy'
        ])
    },
    methods: {
        ...mapActions([
            'setLayout',
            'compatMode',
            'updateSortBy',
            'sortItems'
        ]),
        getType(){
            this.type = this.$route.path.replace(/\\|\/builder\//g,'') 
            return this.type
        },
        show () {
            this.sortByClicked = true;
        },
        setActiveFilter(filter, type){
            var af = this.activeFilters.map((item)=> item)
            var item = this.getFiltersSortHub[type]
            var itemKeys = Object.keys(item)
            for(var i = 0; i< itemKeys.length; i++){
                var itemKeyArray = item[itemKeys[i]]
                if(itemKeyArray.includes(filter)){
                    console.log('itemKeyArray ', itemKeyArray +' includes ', filter)
                    if(!this.activeFiltersV2[type]){
                        this.activeFiltersV2[type] = {}
                    }
                    if(!this.activeFiltersV2[type][itemKeys[i]]){
                        this.activeFiltersV2[type][itemKeys[i]] = []
                    }
                    if(this.activeFiltersV2[type][itemKeys[i]].includes(filter)){
                        console.log('removing ' + filter + ' from '+this.activeFiltersV2[type][itemKeys[i]])
                        if(this.activeFiltersV2[type][itemKeys[i]].length <2){
                            console.log('array length < 2, setting ', this.activeFiltersV2[type][itemKeys[i]], 'to []')
                            this.activeFiltersV2[type][itemKeys[i]] = []
                            this.activeFilters = af.filter((item)=>item!==filter)
                            console.log('array cleared successfully, ', this.activeFiltersV2[type][itemKeys[i]])
                            return 
                        }
                        else {
                            console.log('array length > 2, filtering ', this.activeFiltersV2[type][itemKeys[i]], 'from ', filter)
                            this.activeFilters = af.filter((item)=>item!==filter)
                            var filtered = this.activeFiltersV2[type][itemKeys[i]].filter((item) => item!==filter)
                            this.activeFiltersV2[type][itemKeys[i]] = filtered
                            // console.log('filtered successfully, ', this.activeFiltersV2[type][itemKeys[i]])
                            console.log('filtered successfully, ', this.activeFiltersV2[type][itemKeys[i]])
                            return 
                        }
                    }
                    if(!this.activeFiltersV2[type][itemKeys[i]].includes(filter)){
                        this.activeFiltersV2[type][itemKeys[i]].push(filter)
                        this.activeFilters.push(filter)
                        console.log('activeFiltersV2 updated: ', this.activeFiltersV2, ' for type ', type)
                        return 
                    }
                }
            }
            if(af.includes(filter)){
                this.activeFilters = af.filter((item)=>item!==filter)
                // console.log(filter +' filter removed from active filters', this.activeFilters)
            }
            else {
                this.activeFilters.push(filter)
                // console.log('active filters updated: '+this.activeFilters, ' for type ', type)
            }
        },
        hide () { 
            if (this.sortByClicked==true ){
            this.sortByClicked = false;}
        }
    },
}
</script>
<style scoped>
.compat-mode-button {
    display: inline-block; 
    vertical-align: top; 
    padding-top: 5px; 
    padding-left: 10px;
    transition: 0.2s;
}
.compat-mode-button:hover {
    cursor: pointer;
}
.compat-mode-button input {
    cursor: pointer;
}
input[type='checkbox'] {
    width: 18px !important;
    height: 18px !important;
    margin-top:-2px;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
    outline: 1px solid #434857;
    border-radius: 1px;
    box-shadow: none;
    font-size: 1em;
    text-align: center;
    line-height: 1em;
    background: #191B20;
    vertical-align: text-bottom !important;
    padding-top: 2px;
    transition: 0.3s;
}
input[type='checkbox']:checked:after {
    content: '✔';
    color: #00bc8c;
}
.active span{
    color: #1997c6;
}
.compat-mode-button:hover span{
    color: #1997c6;
}
.compat-mode-button:hover span input[type='checkbox'] {
    outline: 1px solid #1997c6;
        opacity: 0.8;

}
.view-options {
    height: 20px;
    display: inline-block;
    margin: 0px;
    text-align: left;
}
.notification {
  background-color: #1997c6;
  color: white;
  text-align: center;
  font-size: 9px !important;
  display: inline-block;
  vertical-align: top;
  margin-left: -10px;
  margin-top: 0px;
  height: 15px;
  width: 15px;
  border-radius: 50%;
}
.view-options span {
  text-transform: capitalize;
  font-size: 24px !important;
}
.view-options span.active {
  color: #1997c6;
}
.list-option:hover, .album-option:hover{
  cursor: pointer;
  color: #1997c6;
}
</style>